import { Link } from '@tanstack/react-router';

import { NavLabel } from '../../components/shell/NavLabel';
import type { PlanTier } from '../../lib/plan';
import { DotOrb } from './orb/DotOrb';
import { pendingCount, useAgentsBoard } from './useAgentsBoard';

const NAV_ORB = 26;

/**
 * Dale Agents sits above the rest of the nav, its dot alive, with what waits
 * for review. Below Max it stays, locked, and never asks for the board.
 */
export function AgentsNavLink({ onNavigate, lock }: { onNavigate?: () => void; lock?: PlanTier }) {
  const boardQuery = useAgentsBoard(!lock);
  const pending = pendingCount(boardQuery.data);
  return (
    <Link
      to="/agentes"
      className="nav-item nav-agents"
      activeProps={{ 'data-status': 'active' }}
      onClick={onNavigate}
    >
      <span className="agents-tile" style={{ width: NAV_ORB, height: NAV_ORB }}>
        <DotOrb size={NAV_ORB} seed={7} onDark />
      </span>
      <span className="nav-agents-label">
        <NavLabel label="Dale Agents" lock={lock} />
      </span>
      {pending > 0 ? (
        <span className="nav-count">
          {pending}
          <span className="sr-only"> por revisar</span>
        </span>
      ) : null}
    </Link>
  );
}
